import EventRecordTypes from "@/types/sv-data/enums/EventRecordTypes";
import { SiteMonitorState } from "./types";

export function getDefaultState(): SiteMonitorState {
    return {
        LastActivity: null,
        AreaNotesVisible: false,
        GroupID: null,
        EventDetails: null,
        EventRecords: [],
        UserID: 0,
        ControllerUserID: 0,
        IsController: false,
        requestingEventRecords: false,
        AdhocLocationEventRecords: [],
        ActiveResponseIDs: {},
        EventRecordsAwaitingAck: {},
        EventRecordsAwaitingAckCount: 0,
        EventRecordsAwaitingRestore: {},
        EventRecordsAwaitingRestoreCount: 0,
		acknowledgeAllEventRecordId: null,
        EventRecordsWithFiles: [],
        SelectedEventRecord: null,
        LatestEventRecordID: 0,
        EventRecordsNoFilterRenderIndex: 0,
        EventRecordFilters: [
            {
                filterIndex: 0,
                filterTitle: "Alarms",
                filterRecordIds: [EventRecordTypes.Alarm],
                showNew: true,
                newCount: 0,
                hasPriorityColumn: true,
                hasLinkedCameraColumn: true,
                filterRecords: [],
                renderIndex: 0,
                enabled: true,
				hasVideoAvailableColumn: true,
				showMatrixGridLocation: true
            },
            {
                filterIndex: 1,
                filterTitle: "Operator",
                filterRecordIds: [
                    EventRecordTypes.IncidentText,
                    EventRecordTypes.ProcessingStartedEvent,
                    EventRecordTypes.AlarmHandlingEvent,
                    EventRecordTypes.EventShare,
                    EventRecordTypes.ForceRestore,
                    EventRecordTypes.AcknowledgeAll
                ],
                filterRecords: [],
                renderIndex: 0,
                enabled: true
            },
            {
                filterIndex: 2,
                filterTitle: "Dispatch",
                filterRecordIds: [
                    EventRecordTypes.InvestigatorDispatched,
                    EventRecordTypes.InvestigatorArrived,
                    EventRecordTypes.InvestigatorLeaving,
                    EventRecordTypes.OperatorNote,
                    EventRecordTypes.GuardNote,
                    EventRecordTypes.InvestigatorEnRoute
                ],
                filterRecords: [],
                renderIndex: 0,
                enabled: false
            },
            {
                filterIndex: 3,
                filterTitle: "Devices",
                filterRecordIds: [
                    EventRecordTypes.CameraEvent,
                    EventRecordTypes.RelayEvent,
                    EventRecordTypes.AudioEvent
                ],
                filterRecords: [],
                renderIndex: 0,
                enabled: false,
				hasVideoAvailableColumn: true
            },
            {
                filterIndex: 4,
                filterTitle: "Actions",
                filterRecordIds: [
                    EventRecordTypes.TaskAdded,
                    EventRecordTypes.TaskCompleted,
                    EventRecordTypes.TaskAssigned,
                    EventRecordTypes.AllEventActionsRemoved,
                    EventRecordTypes.ActionPlanOverride,
                    EventRecordTypes.RequiredActionsBypassed
                ],
                filterRecords: [],
                renderIndex: 0,
                enabled: true
            },
            {
                filterIndex: 5,
                filterTitle: "Notes",
                filterRecordIds: [
                    EventRecordTypes.SupplementaryData,
                    EventRecordTypes.OperatorNote,
                    EventRecordTypes.InvolvedPartyAdded,
                    EventRecordTypes.InvolvedPartyRemoved,
                    EventRecordTypes.InvolvedPartyAnonymized
                ],
                showNew: true,
                newCount: 0,
                clearNewOnView: true,
                filterRecords: [],
                renderIndex: 0,
                enabled: true
            },
            {
                filterIndex: 6,
                filterTitle: "Messages",
                filterRecordIds: [
                    EventRecordTypes.OperatorMessage,
                    EventRecordTypes.GuardMessage
                ],
                showNew: true,
                newCount: 0,
                clearNewOnView: true,
                filterRecords: [],
                renderIndex: 0,
                enabled: true
            }
        ],
        EventRecordsFilterActiveIndex: -1,
        EventDetailsOpen: false,
        EventRaiseOpen: false,
        EventSharingOpen: false,
        EventCloseOpen: false,
        EventLeaveOpen: false,
        EventLeaveNote: null,
        PutEventOnTestOpen: false,
        InvolvedPartyOpen: false,
        ForceRestoreEventRecord: null,
        EventNoPermission: false,
        IncidentReportOpen: false,
        IncidentReportDownloaded: false,
        EventShares: [],
        MobileEventShares: [],
        ShareWithPersons: [],
        AdhocShareDetails: {},
        EventSharesSet: false,
        userShares: {},
        ExternalUsersAllowed: false,
        activeMapItems: null,
        mapCircleCenter: null,
        eventLocationLastSet: 0,
        auditService: null,
        MaskReasons: [],
        GroupMaskReasons: [],
        MaskedAlarms: [],
        Events: [],
        ActiveMapItemsRequired: true,
        IsUploadingFile: false,
        hideMapFlag: false,
		deviceServerDetails: [],
		applianceServerDetails: [],
		applianceServerAndDeviceServerPollingStatus: {
			isPolling: false,
			intervalHandlerId: 0
		},
		eventCaseId: null,
        goToLocation: null,
        eventOutcomes: {
            eventOutcomeTree: [],
            eventOutcomeFlatList: []
        },
        areaDetailsTabIndex: 0,
        notifyNotificationRules: null,
        involvedParties: [],
        notificationRulesContributingToNotification: []
    }
}
